import { Scales } from "@phosphor-icons/react";
import { compare, useLocalList } from "@/lib/storage";
import { toast } from "sonner";

export default function CompareCheckbox({ id, className = "" }) {
  const list = useLocalList(compare);
  const active = list.includes(id);
  function toggle(e) {
    e.preventDefault(); e.stopPropagation();
    const r = compare.toggle(id);
    if (r.full) toast.error("Maximum 4 properties to compare.");
  }
  return (
    <button
      type="button" onClick={toggle}
      className={`w-10 h-10 flex items-center justify-center transition-colors shadow-sm ${
        active ? "bg-[#001588] text-white" : "bg-white text-[#001588] hover:bg-[#001588] hover:text-white"
      } ${className}`}
      aria-label={active ? "Remove from compare" : "Add to compare"}
      data-testid={`compare-${id}`}
    >
      <Scales size={16} weight={active ? "fill" : "regular"} />
    </button>
  );
}
